module.exports = __webpack_public_path__ + "ecdf7ebf2fb276b3a0c7ba64e9bf3ef5.jpg";